import Splide from "@splidejs/splide"

const sliders = {
  init() {
    this.noSlider()
    this.setHeroSliders()
    this.setProdSliders()
    this.setBrandsSlider()
    this.setFtBrandsSlider()
    this.setBeforeAfter()
    this.setProdThumbnailsSlider()
    this.resetSlider()
    this.setCategoriesSlider()
  },
  resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider()
    })
  },
  noSlider() {
    const noSlider = document.querySelectorAll(".jsNoSlider") as NodeListOf<HTMLElement>

    noSlider.forEach((item) => {
      const items = item.querySelectorAll(".splide__slide") as NodeListOf<HTMLElement>
      const minSlideNum = item.dataset.items as string
      if ((item.dataset.width && +item.dataset.width > window.innerWidth) || items.length <= +minSlideNum) {
        item.classList.remove("splide")
        item.classList.remove("jsCatSlider")
        item.classList.remove("jsProdSlider")
        item.firstElementChild?.classList.remove("splide__track")
        const list = item.firstElementChild?.firstElementChild
        list?.classList.remove("splide__list")
        list?.classList.add("splide__grid")

        if (items) {
          Array.from(items).forEach((el) => {
            const item = el as HTMLElement
            item.classList.remove("splide__slide")
          })
        }
      }
    })
  },
  setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as HTMLElement | undefined
    const thumbnails = document.getElementById("thumbnails") as HTMLElement | undefined

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      })

      const thumbnailsNav = new Splide(thumbnails, {
        direction: "ttb",
        isNavigation: true,
        pagination: false,
        heightRatio: 4,
        perPage: 4,
        arrows: false,
        gap: "20px",
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 3,
            heightRatio: 1,
            fixedHeight: "70px",
          },
        },
      })

      main.sync(thumbnailsNav)
      main.mount()
      thumbnailsNav.mount()
    }
  },

  setHeroSliders() {
    const heroSliders = document.querySelectorAll(".jsHeroSlide") as NodeListOf<HTMLElement>
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        perPage: 1,
        type: 'loop',
        speed: 800,
        arrows: true,
      })
      slider.mount()
    })
  },
  setProdSliders() {
    const porductSliders = document.querySelectorAll(".jsProdSlider") as NodeListOf<HTMLElement>

    porductSliders.forEach((el) => {
      new Splide(el, {
        perPage: 5,
        pagination: false,       
        speed: 800,
        gap: "100px",
        breakpoints: {
          1200: {
            gap: "50px",
          },
          768: {
            perPage: 4,
            gap: "10px",
          },
          480: {
            perPage: 2,
            gap: "10px",
          },
        },
      }).mount()
    })
  },
  setBrandsSlider() {
    const brandsSlider = document.getElementById("brandsSlider") as HTMLElement | undefined
    if (brandsSlider) {
      new Splide(brandsSlider, {
        perPage: 6,
        
        pagination: false,
        speed: 800,
        gap: "60px",
        breakpoints: {
          1199: {
            perPage: 4,
          },
          767: {
            perPage: 2,
            gap: "25px",
          },
        },
      }).mount()
    }
  },
  setFtBrandsSlider() {
    const ftBrandsSlider = document.getElementById("ftBrandsSlider") as HTMLElement | undefined

    if (ftBrandsSlider) {
      new Splide(ftBrandsSlider, {
        perPage: 5,
        
        pagination: false,
        speed: 800,
        gap: "60px",
        breakpoints: {
          1199: {
            perPage: 4,
          },
          767: {
            perPage: 2,
            gap: "25px",
          },
        },
      }).mount()
    }
  },
  setBeforeAfter() {
    const beforeAfter = document.getElementById("beforeAfter") as HTMLElement | undefined
    if (beforeAfter) {
      new Splide(beforeAfter, {
        perPage: 5,
        pagination: false,
        speed: 800,
        
        gap: "40px",
        breakpoints: {
          1199: {
            perPage: 4,
          },
          767: {
            perPage: 2,
            gap: "25px",
          },
          400: {
            perPage: 1,
          },
        },
      }).mount()
    }
  },

  setCategoriesSlider() {
    const categoriesSlider = document.querySelectorAll(".jsCatSlider") as NodeListOf<HTMLElement>
    categoriesSlider.forEach((el) => {
      new Splide(el, {
        perPage: 5,
        pagination: false,
        speed: 800,
        
        arrows: true,
        gap: "50px",
        breakpoints: {
          1200: {
            perPage: 3,
          },
          768: {
            perPage: 2,
            gap: "25px",
          },
          500: {
            perPage: 1,
          },
        },
      }).mount()
    })
  },
}

export default sliders
